import { Outlet } from 'react-router-dom';
import greenpillBg from '../assets/greenpill/greenpillBg.png';

function Greenpill() {
    return (
        <div
            style={{
                backgroundImage: `url(${greenpillBg})`,
                background: 'black',
                backgroundPosition: 'center',
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
            }}
            className="p-9 extraSize"
        >
            <Outlet />
        </div>
    );
}

export default Greenpill;
